const initialState = {
  users: { data: [] },
  user: {},
  permissions: [],
  general: {},
  delete_modal: false,
  loading: false,
  dashboard: {},
  roles: [],
  mainCategory: [],
  companyConfig: [],
  variantTypes: [],
  variants: [],
  carousel: [],
};

export const user_reducer = (state = initialState, action) => {
  switch (action.type) {
    //   case "LOGIN":
    //       return{
    //           ...state,
    //           user:action.payload,
    //           permissions:action.payload?.permissions?action.payload?.permissions:{},
    //           loading:false
    //       }
    case "GET_MY_PROFILE":
      return {
        ...state,
        user: action.payload,
        permissions: action.payload.permissions,
      };
    case "GET_GEN_DOC":
      return {
        ...state,
        general: action.payload,
      };
    case "GET_APP_CONFIG":
      return {
        ...state,
        mainCategory: action.payload.mainCategory,
      };
    case "GET_CAROUSEL":
      return {
        ...state,
        carousel: action.payload,
      };
    case "GET_SETTINGS":
      return {
        ...state,
        companyConfig: action.payload.companyConfig,
        variantTypes: action.payload.variantTypes,
        variants: action.payload.variants,
      };
    case "GET_ROLES":
      return {
        ...state,
        roles: action.payload,
      };
    case "GET_USERS":
      return {
        ...state,
        users: action.payload,
      };
    case "GET_ADMINS":
      return {
        ...state,
        admins: action.payload,
      };
    case "DELETE_USER":
      return {
        ...state,
        users: { ...state.users, data: state.users.data.filter((li) => li.id !== action.payload) },
      };

    case "DELETE_ROLE":
      return {
        ...state,
        roles: state.roles.filter((li) => li.id !== action.payload),
      };
    case "UPDATE_USER_STATUS":
      let update_users1 = state.users.data;
      update_users1.map((usr) => {
        if (usr.id === action.payload.id) {
          usr.is_active = !action.payload.is_active;
        }
      });
      return {
        ...state,
        users: { ...state.users, data: update_users1 },
      };

    case "SHOW_DELETE_MODAL":
      return {
        ...state,
        delete_modal: action.payload,
      };
    case "CLEAR_STORE":
      return {
        users: { data: [] },
        user: {},
        permissions: [],
        general: {},
        delete_modal: false,
        loading: false,
        dashboard: {},
        roles: [],
      };
    case "GET_USER_ORDERS":
      let old_items2 = action.payload;
      if (action.data) {
        old_items2 = [...state.orders, ...action.payload];
      }
      return {
        ...state,
        orders: old_items2,
      };
    default:
      return state;
  }
};
